























































































import { Component, Vue } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import { pageBillOperationLogs, ACTION_MAP } from '@/api/billAppLog'

@Component({
  name: 'BillAppLog',
  components: { Empty }
})
export default class extends Vue {
  private loading = false
  private isSearch = false
  private tableData: any[] = []
  private keyword = ''
  private actionFilter = ''
  private dateRange: string[] = []
  private page = 1
  private pageSize = 20
  private total = 0

  private actionOptions = [
    { value: 'create_bill', label: '新增账单' },
    { value: 'auto_create_bill', label: '自动记账' },
    { value: 'update_bill', label: '修改账单' },
    { value: 'delete_bill', label: '删除账单' },
    { value: 'save_pending', label: '保存待确认' },
    { value: 'confirm_pending', label: '确认账单' },
    { value: 'reject_pending', label: '拒绝待确认' },
    { value: 'register', label: '注册账号' },
    { value: 'login', label: '登录账号' },
    { value: 'upload_release', label: '发布版本' }
  ]

  created() {
    this.loadData()
  }

  private formatAction(action: string) {
    return ACTION_MAP[action] || action || '未知'
  }

  private formatTime(v: string) {
    if (!v) return '—'
    return String(v).replace('T', ' ').slice(0, 19)
  }

  private actionTagType(action: string) {
    if (action === 'delete_bill' || action === 'reject_pending') return 'danger'
    if (action === 'upload_release') return 'warning'
    if (action === 'create_bill' || action === 'auto_create_bill' || action === 'confirm_pending') {
      return 'success'
    }
    return 'info'
  }

  private buildParams() {
    return {
      page: this.page,
      pageSize: this.pageSize,
      keyword: this.keyword || undefined,
      action: this.actionFilter || undefined,
      startDate: this.dateRange && this.dateRange[0] ? this.dateRange[0] : undefined,
      endDate: this.dateRange && this.dateRange[1] ? this.dateRange[1] : undefined
    }
  }

  private async loadData() {
    this.loading = true
    try {
      const res = await pageBillOperationLogs(this.buildParams())
      this.tableData = (res && res.records) ? res.records : []
      this.total = (res && res.total) ? res.total : 0
    } catch (e) {
      this.tableData = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }

  private reload() {
    this.isSearch = !!(this.keyword || this.actionFilter || (this.dateRange && this.dateRange.length))
    this.page = 1
    this.loadData()
  }

  private handleSizeChange(size: number) {
    this.pageSize = size
    this.page = 1
    this.loadData()
  }

  private handleCurrentChange(p: number) {
    this.page = p
    this.loadData()
  }
}
